import React from "react";
import { useSelector } from "react-redux";

const ZhDashboard = () => {
  const userData = useSelector((state) => state.auth.employeeDetails);

  if (!userData) {
    return <div className="p-6">Loading...</div>;
  }

  return (
    <div className="min-h-screen p-6">
      <div className="max-w-4xl mx-auto space-y-6">

        {/* HEADER */}
        <div className="bg-white rounded-2xl shadow px-6 py-4">
          <h1 className="text-xl font-bold text-slate-800">
            ASM Dashboard
          </h1>
          <p className="text-sm text-slate-500">
            Regional Manager Profile
          </p>
        </div>

        {/* BASIC INFORMATION */}
        <div className="bg-white rounded-2xl shadow p-6">
          <h2 className="text-lg font-semibold mb-4 text-indigo-600">
            Basic Information
          </h2>

          <div className="flex justify-between py-2 border-b">
            <span className="text-sm text-slate-500">Username</span>
            <span className="text-sm font-semibold">{userData.username || "—"}</span>
          </div>

          <div className="flex justify-between py-2 border-b">
            <span className="text-sm text-slate-500">User ID</span>
            <span className="text-sm font-semibold">{userData.userId || "—"}</span>
          </div>

          <div className="flex justify-between py-2 border-b">
            <span className="text-sm text-slate-500">Role</span>
            <span className="text-sm font-semibold">{userData.role || "—"}</span>
          </div>

          <div className="flex justify-between py-2 border-b">
            <span className="text-sm text-slate-500">Mobile</span>
            <span className="text-sm font-semibold">{userData.mobile_number || "—"}</span>
          </div>

          <div className="flex justify-between py-2">
            <span className="text-sm text-slate-500">Email</span>
            <span className="text-sm font-semibold break-all">
              {userData.email || "—"}
            </span>
          </div>
        </div>

        {/* BANK DETAILS */}
        <div className="bg-white rounded-2xl shadow p-6">
          <h2 className="text-lg font-semibold mb-4 text-indigo-600">
            Bank Details
          </h2>

          <div className="flex justify-between py-2 border-b">
            <span className="text-sm text-slate-500">Bank Account No</span>
            <span className="text-sm font-semibold">
              {userData.bank_account_no || "—"}
            </span>
          </div>

          <div className="flex justify-between py-2 border-b">
            <span className="text-sm text-slate-500">IFSC</span>
            <span className="text-sm font-semibold">
              {userData.bank_ifsc || "—"}
            </span>
          </div>

          <div className="flex justify-between py-2">
            <span className="text-sm text-slate-500">Merchant Account No</span>
            <span className="text-sm font-semibold">
              {userData.merchant_account_no || "—"}
            </span>
          </div>
        </div>

      </div>
    </div>
  );
};

export default ZhDashboard;
